export default __webpack_public_path__ + "static/cover-f1e1a4c14bf59847d25307474f9f6308.png";